import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { getTestsByProjectId } from "../../services/api";
import Breadcrumbs from "../../components/BreadCrumbs";
import { formatDate, formatCurrency } from "../../utils/utils";

const TestListXProject = () => {
  const { projectId } = useParams();
  const [tests, setTests] = useState([]);

  useEffect(() => {
    const fetchTests = async () => {
      try {
        const response = await getTestsByProjectId(projectId);
        setTests(response);
      } catch (error) {
        console.error("Error al obtener los casos de prueba", error);
      }
    };
    fetchTests();
  }, [projectId]);

  // Definir las rutas para los breadcrumbs
  const breadcrumbPaths = [
    { name: "Dashboard", url: "/dashboard" },
    { name: "Projects", url: "/dashboard/projects" },
    { name: "Test", url: "/dashboard/projects" + projectId + "/test" },
  ];

  return (
    <>
      <h3>Casos de Prueba</h3>
      <Breadcrumbs paths={breadcrumbPaths} />

      <Link
        to={`/dashboard/projects/${projectId}/tests/create`}
        className="btn btn-primary mb-3"
      >
        Crear Caso de Prueba
      </Link>

      {tests && tests.length > 0 ? (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Fecha de creación</th>
              <th>Asignado a</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {tests.map((test) => (
              <tr key={test.caso_prueba_id}>
                <td>{test.caso_prueba_id}</td>
                <td>{test.nombre}</td>
                <td>{test.descripcion}</td>
                <td>{formatDate(test.createdAt)}</td>
                <td>{test.assignedTo}</td>
                <td>{test.estado}</td>
                <td>
                  <Link
                    to={`update/${test.caso_prueba_id}`}
                    className="btn btn-sm btn-secondary ml-2"
                  >
                    Editar
                  </Link>
                  <Link
                    to={`/projects/${projectId}/tests/delete/${test.caso_prueba_id}`}
                    className="btn btn-sm btn-danger ml-2"
                  >
                    Eliminar
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No hay proyectos disponibles.</p>
      )}
    </>
  );
};

export default TestListXProject;
